import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Logo from '../Logo';
import PPPBanner from '../Common/PPPBanner';

import MobileNav from '../MobileNav';
import HeaderLinks from './HeaderLinks';
import HamburgerIcon from './HamburgerIcon';

import NavigationLinks from './NavigationLinks';

import * as styles from './HeaderComponent.module.less';

const HeaderComponent = props => {
  const {
    logoImage,
    logoURL,
    navigationLinks,
    headerLinks,
    headerButton,
    secondaryNav,
    hideSubmenu,
    fullWidth,
    mobileButton,
    hideHamburgerIcon,
  } = props;
  const [mobileNavVisible, setMobileNavVisible] = useState(false);

  return (
    <nav className={styles.wrapper}>
      <PPPBanner />
      <header
        className={classNames(styles.header, {
          [styles.full]: fullWidth,
        })}
      >
        <Logo logoImage={logoImage} logoURL={logoURL} />
        <div className={styles.navigationLinks}>
          <NavigationLinks links={navigationLinks} hideSubmenu={hideSubmenu} />
        </div>
        <div className={styles.accountActions}>
          <HeaderLinks links={headerLinks} headerButton={headerButton} />
          {!hideHamburgerIcon && (
            <HamburgerIcon
              mobileNavVisible={mobileNavVisible}
              setMobileNavVisible={setMobileNavVisible}
            />
          )}
        </div>
      </header>
      <MobileNav
        isVisible={mobileNavVisible}
        links={headerLinks}
        headerButton={mobileButton}
        navigationLinks={navigationLinks}
      />
      {secondaryNav}
    </nav>
  );
};

HeaderComponent.propTypes = {
  logoImage: PropTypes.number,
  logoURL: PropTypes.string,
  navigationLinks: PropTypes.arrayOf(PropTypes.any),
  headerLinks: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      text: PropTypes.string,
    })
  ),
  mobileButton: PropTypes.shape({
    url: PropTypes.string,
    text: PropTypes.string,
  }),
  headerButton: PropTypes.shape({
    url: PropTypes.string,
    text: PropTypes.string,
  }),
  secondaryNav: PropTypes.node,
  hideSubmenu: PropTypes.bool,
  fullWidth: PropTypes.bool,
  hideHamburgerIcon: PropTypes.bool,
};

HeaderComponent.defaultProps = {
  logoImage: 0,
  logoURL: '/',
  headerLinks: [],
  headerButton: null,
  mobileButton: null,
  navigationLinks: [],
  secondaryNav: null,
  hideSubmenu: false,
  fullWidth: false,
  hideHamburgerIcon: false,
};

export default HeaderComponent;
